export default "__VITE_ASSET__CVIjG7Gs__"